
import React from 'react';

const TaiNguyenPage = () => {
    return (
        <div>
            TaiNguyenPage
        </div>
    );
};

export default TaiNguyenPage;